<!--任务详情-->
<template>
  <!-- 顶部商品信息 -->
  <el-card shadow="hover" style="position: relative;padding-left: 20px" class="top-warp">
    <div class="top-wrap_con">
      <label class="top-tit">
        <label>任务信息：</label>
        <label class="top-code">{{this.taskEdit.code}}</label>
      </label>
      <el-row style="padding-left: 50px">
        <el-col :span="8" class="assignment-content">
          <label>供应商：{{this.taskEdit.supplier}}</label>
          <label>创建日期：{{this.taskEdit.createTime}}</label>
          <label>接单日期：{{this.taskEdit.acceptTime}}</label>
          <label>完成日期：{{this.taskEdit.finishTime}}</label>
          <label  v-if="taskEdit.typeName==='多余退货'||taskEdit.typeName==='售后退货'||taskEdit.typeName==='出货'||taskEdit.typeName==='补货' ||taskEdit.typeName==='拒收入库'">配送仓点：{{this.taskEdit.ydppName}}</label>
        </el-col>
        <el-col :span="8" class="assignment-content">
          <label v-if="taskEdit.status === 1">状态：未接单</label>
          <label v-if="taskEdit.status === 2 && taskEdit.nature!=2">状态：拣货中</label>
          <label v-else-if="taskEdit.status === 2 && taskEdit.nature!=1">状态：进行中</label>
          <label v-if="taskEdit.status === 3">状态：已完成</label>
          <label v-if="taskEdit.status === 4">状态：已取消</label>
          <label v-if="taskEdit.status === 5">状态：配送中</label>
          <label>任务类型：{{this.taskEdit.typeName}}</label>
          <label v-if="isShowPlate">
            配送板数：{{taskEdit.plate}}
            <el-tooltip class="item" effect="dark" :content="'系统计算板数：' + taskEdit.relPlate" placement="right-start">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </label>
          <label v-if="!isShowPlate">装卸服务：
            <span v-if="taskEdit.loading === 1">需要</span>
            <span v-if="taskEdit.loading === 0">不需要</span>
          </label>
          <label>取消时间：{{taskEdit.cancelTime}}</label>
          <!-- 原先·入库任务显示备注 -->
          <label class="note">
            <p>备注：</p>
            <p>{{ taskEdit.note }}</p>
          </label>
        </el-col>
        <el-col :span="8" class="assignment-content">
        </el-col>
      </el-row>
      <el-button class="print-top-btn"
                 @click="toPreviewPrint(1)"
                 v-if="(taskEdit.typeName != '盘点入库' && taskEdit.typeName != '盘点出库') && userInfo.identity !==3 && (taskEdit.status === 2 || taskEdit.status === 3)">{{natures == 2 ? '打印入库单' : '打印出库单'}}</el-button>
      <el-button class="print-bot-btn"
                 @click="toPreviewPrint(2)"
                 v-if="(taskEdit.typeName != '盘点入库' && taskEdit.typeName != '盘点出库') && userInfo.identity !==3 && ((userInfo && (userInfo.isLmOpen == 1 || userInfo.isMdOpen == 1) && (taskEdit.status == 1 || taskEdit.status == 2)) || ((taskEdit.status == 3 || taskEdit.status == 4) && taskEdit.finishYocType == 1))">打印拣货单</el-button>
    </div>
  </el-card>
</template>
 
<script>
// import assignmentManage from '@/store/assignmentManage/index'
import {SAVETASKPRINTBILLOUTDATA, SAVETASKPRINTBILLPICKDATA, SAVETASKPRINTBILLINTODATA} from '@/store/assignmentManage/types.js'
import user from '@/store/user/index'
export default {
  props: ['taskEdit'],
  data () {
    return {
      code: this.$route.params.code,
      natures: this.$route.params.nature || false
    }
  },
  methods: {
    
    // 打印面單
    toPreviewPrint (mode) {
      let goodsListEdit = this.$parent.goodsListEdit
      console.log(goodsListEdit,'goodsListEdit');
      
      goodsListEdit.forEach(x => {
        if (!x.batchList || !x.batchList.length) {
          x.productionTime = '无'
        }
        if (x.batchList && x.batchList.length) {
          x.batchList.forEach(y => {
            if (!y.productionTime) {
              y.productionTime = '无'
            }
          })
        }
        if (!x.barCode) {
          x.barCode = ''
        }
        
      })
      let goodsTotalPiece = ''
      goodsTotalPiece = (this.$parent.taskEdit.actualNum || 0) + '件'
      let goodsSku = goodsListEdit.length
      if (mode === 1) {
        // eslint-disable-next-line eqeqeq
        if (this.natures == 2) {
          this.$store.dispatch(SAVETASKPRINTBILLINTODATA, {goodsListEdit, goodsTotalPiece, goodsSku}).then(() => {
            this.$router.push(`/assignmentManage/warehouseIntoPrinttemp/${this.code}/${mode}/${this.natures}`)
          })
        } else {
          this.$store.dispatch(SAVETASKPRINTBILLOUTDATA, {goodsListEdit, goodsTotalPiece, goodsSku}).then(() => {
            this.$router.push(`/assignmentManage/warehouseOutPrinttemp/${this.code}/${mode}/${this.natures}`)
          })
        }
      } else if (mode === 2) {
        let newGoodList = goodsListEdit.filter(x => {
          console.log((!x.batchList) || (!x.batchList.length));
          
          return (!x.batchList) || (!x.batchList.length)
        })
        console.log(newGoodList);
        let newBatchList = goodsListEdit.filter(x => {
          return x.batchList && x.batchList.length
        })
       
        newBatchList.forEach(item => {
          //  console.log(item.goodsShelvesWarehouseAddressNames);
          let one = {name: item.name, barCode: item.barCode,goodsShelvesWarehouseAddressNames:item.goodsShelvesWarehouseAddressNames}
          item.batchList.map(info => {
            // 计算箱+件
            this.getBoxNumber(info, item)
            
            let entire = Object.assign({}, one, info)
            newGoodList.push(entire)
          })
        })
        console.log(newGoodList);
        
        this.$store.dispatch(SAVETASKPRINTBILLPICKDATA, {goodsListEdit: newGoodList, goodsTotalPiece, goodsSku}).then(() => {
          this.$router.push(`/assignmentManage/warehousePickingPrinttemp/${this.code}/${mode}/${this.natures}`)
        })
      }
    },
    // 计算箱+件
    getBoxNumber (info, item) {
      let list = [
        {key: 'normalBox', val: 'normal'},
        {key: 'unNormalBox', val: 'unNormal'},
        {key: 'normaledBox', val: 'normaled'},
        {key: 'normalCancelBox', val: 'normalCancel'},
        {key: 'brokenBox', val: 'broken'},
        {key: 'unBrokenBox', val: 'unBroken'},
        {key: 'brokenedBox', val: 'brokened'},
        {key: 'brokenCancelBox', val: 'brokenCancel'}
      ]
      list.forEach(x => {
        info[x.key] = `${Math.floor(info[x.val] / item.box)}${item.maxUnitName}${info[x.val] % item.box}${item.minUnitName}`
      })
    }
  },
  computed: {
    // 是否显示配送板数
    isShowPlate () {
      return this.taskEdit.status === 3 && this.taskEdit.computeType === 'RECKON_TYPE_PLATE' && (this.taskEdit.typeName === '多余退货' || this.taskEdit.typeName === '售后退货' || this.taskEdit.typeName === '出货' || this.taskEdit.typeName === '补货')
    },
    // 用户信息
    userInfo () {
      console.log(user)
      return user.state.userinfo
    }
  }
}
</script>
 
<style scoped>
  .top-warp {
    padding-left: 20px;
  }
  .top-tit{
    font-size: 20px;
    padding-bottom: 30px;
    display: flex;
    font-weight: bold;
    color: #696969;
  }
  .top-code {
    font-size: 18px;
    line-height: 31px;
    height: 30px;
    overflow: hidden;
  }
  .assignmentedit-List {
    padding-left: 20px;
  }
  .assignment-content {
    flex-direction: column;
    display: flex;
  }
  .assignment-content label {
    padding: 5px 0;
  }
  .btm-button {
    width: 58%;
    margin-left: auto;
    padding-top: 20px;
  }
  .operation-warp {
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: #409EFF;
    cursor: pointer;
  }
  .operation-warp div:hover {
    color: #66b1ff;
  }
  .add-search {
    display: flex;
    width: 48%;
    justify-content: space-between;
    padding-bottom: 20px;
  }
  .btm-label {
    display: flex;
    flex-direction: column;
  }
  .btm-confirm {
    width: 80%;
    margin: 0 auto;
    overflow: hidden;
  }
  .demo-ruleForm >>> .el-dialog__body {
    height: auto !important;
  }
  .assignmentedit-List >>> .el-table .cell{
    white-space:pre-line;
  }
  .upload-text {
    color: #444;
    opacity: 0.9;
    font-family: sans-serif;
    font-size: 15px;
  }
  .print-top-btn {
    position: absolute;
    top: 30px;
    right: 100px;
  }
  .print-bot-btn {
    position: absolute;
    top: 75px;
    right: 100px;
  }
  .note{
    display: flex;
  }
  .note p:nth-child(1){
    white-space: nowrap;
  }
  .note p:nth-child(2){
    flex-grow: 1;
  }
</style>


// WEBPACK FOOTER //
// src/page/assignmentManage/components/editTaskInfo.vue